import { useEffect, useState } from "react";
import fallbackCourses from "../data/courses";
import { API_BASE, COURSES_COLLECTION } from "../config";

const buildImageUrl = (record) => {
  if (record.imageUrl) {
    return record.imageUrl;
  }

  if (record.image) {
    return `${API_BASE}/files/${record.collectionId}/${record.id}/${record.image}`;
  }

  return "/assets/d.jpg";
};

const mapCourseRecord = (record) => ({
  id: record.id,
  title: record.title,
  slug: record.slug,
  shortDescription: record.shortDescription || "",
  longDescription: record.longDescription || "",
  price: Number(record.price || 0),
  originalPrice: record.originalPrice ? Number(record.originalPrice) : null,
  category: record.category || "General",
  image: buildImageUrl(record),
  rating: {
    rate: Number(record.ratingRate || 4.8),
    count: Number(record.ratingCount || 0),
  },
});

const useCourses = () => {
  const [courses, setCourses] = useState(fallbackCourses);

  useEffect(() => {
    const controller = new AbortController();

    const fetchCourses = async () => {
      try {
        const response = await fetch(
          `${API_BASE}/collections/${COURSES_COLLECTION}/records?perPage=200&sort=title&filter=${encodeURIComponent(
            "active=true"
          )}`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          throw new Error("No se pudo cargar el catalogo desde PocketBase");
        }

        const payload = await response.json();
        const records = Array.isArray(payload?.items) ? payload.items : [];

        setCourses(records.map(mapCourseRecord));
      } catch (error) {
        if (error.name !== "AbortError") {
          setCourses(fallbackCourses);
        }
      }
    };

    fetchCourses();

    return () => controller.abort();
  }, []);

  return courses;
};

export default useCourses;
